import mitt from 'mitt'

type Events = {
  alertMessage: string
  // Define the new event and the type of data it carries
  networkError: 'offline' | 'server-unreachable'
}

export const eventBus = mitt<Events>()
